import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable()
export class ConsignmentsService {

  httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  constructor(private http: HttpClient) { }

  getConsignments() {
      return this.http.get('/consignments');
  }
  getNewConsignments() {
    let config = {
      headers: new HttpHeaders({'Content-Type':'application/json'})
  };
  config["params"] = {
      filter: JSON.stringify({where:{"status":null}})
  };
    return this.http.get('/consignments', config);
}
  createConsignment(data) {
      let body = JSON.stringify(data);
      return this.http.post('/consignments/', body, this.httpOptions);
  }

  updateConsignment(data) {
      let body = JSON.stringify(data);
      return this.http.put('/consignments/' + data.id, body, this.httpOptions);
  }

  deleteConsignment(data) {
      return this.http.delete('/consignments/' + data.id);
  }

  getAnalytics(data){
    let config = {
      headers: new HttpHeaders({'Content-Type':'application/json'})
  };
  config["params"] = {
      filter: JSON.stringify({where:{"startDate	":data.startDate,"endDate":data.endDate}})
  };
  return this.http.get('/consignments/getConsignmentAnalytics', config);
  }

  getCount(){
    return this.http.get('/consignments/count');
  }

  getConsignmentById(Id:string) {
    return this.http.get('/consignments/'+Id,this.httpOptions);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/shipments/consignments/consignment.service.ts